import { render, staticRenderFns } from "./NewProductPricesList.vue?vue&type=template&id=6a5e075e&"
import script from "./NewProductPricesList.vue?vue&type=script&lang=js&"
export * from "./NewProductPricesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports